module.exports = __webpack_public_path__ + "static/media/ReportNavIconActive.619105bf.svg";